// extracted by mini-css-extract-plugin
export var button = "_js-0";
export var donut = "_js-1";
export var donutFill = "_js-3";
export var donutTrack = "_js-2";